module.exports = __webpack_public_path__ + "img/Group 100@2x.64d6165a.png";